import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { ClientStatementAccountDetailValidation } from 'uplisting-frontend/validations';

export default class ClientStatementAccountDetailRepositoryService extends BaseRepositoryService<
  ModelRegistry['client-statement-account-detail']
> {
  recordName = 'client-statement-account-detail';
  implementMethods = ['findAll', 'buildChangeset'];

  validation = ClientStatementAccountDetailValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/client-statement-account-detail': ClientStatementAccountDetailRepositoryService;
  }
}
